import { createFileRoute } from "@tanstack/react-router";
import { AboutPage } from "@/pages/about-us";
import { head, loader } from "@/pages/about-us.meta";

export const Route = createFileRoute("/$locale/about-us")({
  loader,
  head,
  component: AboutPage,
});
